import { EnvironmentProviders, inject, Injectable, provideAppInitializer, signal } from '@angular/core'
import { Router } from '@angular/router'
import { SessionStateService } from '../auth/session-state.service'
import { GLOBAL_COMMANDS, withRun } from './shortcut-catalog'
import { ShortcutDispatcherService } from './shortcut-dispatcher.service'
import { ShortcutPreferencesService } from './shortcut-preferences.service'
import { ShortcutRegistryService } from './shortcut-registry.service'
import { GLOBAL_SCOPE, ShortcutCommand } from './shortcut.types'

/** UI state for the "?" cheat-sheet overlay rendered by the root App component. */
@Injectable({ providedIn: 'root' })
export class ShortcutCheatSheetState {
    readonly open = signal(false)
}

function globalCommands (): Array<ShortcutCommand> {
    const router = inject(Router)
    const session = inject(SessionStateService)
    const cheatSheet = inject(ShortcutCheatSheetState)
    const panel = () => session.user?.userable_type as string | undefined
    const inPanel = () => panel() === 'workshop' || panel() === 'customer'

    return [
        withRun(GLOBAL_COMMANDS.cheatSheet, () => cheatSheet.open.update(v => !v)),
        withRun(GLOBAL_COMMANDS.settings, () => router.navigateByUrl(`/${panel()}/keyboard-shortcuts`), { when: inPanel }),
        withRun(GLOBAL_COMMANDS.dashboard, () => router.navigateByUrl(`/${panel()}/dashboard`), { when: inPanel }),
        withRun(GLOBAL_COMMANDS.downloadLogs, () => router.navigateByUrl('/workshop/download-logs'), { when: () => panel() === 'workshop' })
    ]
}

/** Starts the shortcut engine and registers the built-in global commands. */
export function provideKeyboardShortcuts (): EnvironmentProviders {
    return provideAppInitializer(() => {
        inject(ShortcutPreferencesService)
        inject(ShortcutRegistryService).register(GLOBAL_SCOPE, globalCommands())
        inject(ShortcutDispatcherService).start()
    })
}
